import request from '@/utils/request'
import { getCommunityId } from '@/api/community/communityApi'

function withCommunity(payload) {
  return {
    ...(payload || {}),
    communityId: (payload && payload.communityId) || getCommunityId()
  }
}

// 查询问卷调研列表
export function listQuestionnaireSurvey(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/question.listQuestionAnswer',
      method: 'get',
      params: params || {}
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 新增问卷调研
export function saveQuestionnaireSurvey(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/question.saveQuestionAnswer',
      method: 'post',
      data: withCommunity(data)
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 更新问卷调研
export function updateQuestionnaireSurvey(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/question.updateQuestionAnswer',
      method: 'post',
      data: withCommunity(data)
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除问卷调研
export function deleteQuestionnaireSurvey(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/question.deleteQuestionAnswer',
      method: 'post',
      data: withCommunity(data)
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 发布问卷调研
export function publishQuestionnaireSurvey(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/question.publishQuestion',
      method: 'post',
      data: withCommunity(data)
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 上传附件
export function uploadQuestionnaireAttachment(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/uploadImage',
      method: 'post',
      headers: { 'Content-Type': 'multipart/form-data' },
      data
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}
